export const AVAILABILITY_FLAGS = {
    ACTIVE: 0x0,
    EXPIRED: 0x1,
    DELETED: 0x2,
};

export const DATA_CONTENT_FLAGS = {
    DESCRIPTION: 0x10,
    HISTORY: 0x20,
};

export const VALUE_SOURCE_FLAGS = {
    ESTIMATED: 0x100,
    OFFICIAL: 0x200,
};

export const UPDATE_STATUS = {
    ACTIVATED: AVAILABILITY_FLAGS.ACTIVE,
    DESCRIBED: DATA_CONTENT_FLAGS.DESCRIPTION,
    ESTIMATED: VALUE_SOURCE_FLAGS.ESTIMATED,
    ESTIMATED_EXPIRED: VALUE_SOURCE_FLAGS.ESTIMATED | AVAILABILITY_FLAGS.EXPIRED,
    OFFICIAL: VALUE_SOURCE_FLAGS.OFFICIAL,
    OFFICIAL_EXPIRED: VALUE_SOURCE_FLAGS.OFFICIAL | AVAILABILITY_FLAGS.EXPIRED,
};

export default {
    AVAILABILITY_FLAGS,
    VALUE_SOURCE_FLAGS,
    DATA_CONTENT_FLAGS,
    UPDATE_STATUS,
};
